export const DATA_QA_MANUAL_FILESIZE = 'manual-filesize';
export const DATA_QA_MANUAL_TEXT_WRAP = 'manual-text-wrap';
export const DATA_QA_MANUALS_WRAP = 'manuals-wrap';
export const DATA_QA_MANUALS = 'manuals';
export const DATA_QA_MANUALS_EMPTY_BLOCK = 'manuals-empty-block';
